import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { Form, InputGroup } from 'react-bootstrap';

type NumberStepperProps = {
    ariaLabel?: string;
    disabled?: boolean;
    max?: number;
    min?: number;
    onChange: (value: number) => void;
    step?: number;
    suffix?: string;
    value: number;
};

/**
 * A number input flanked by minus/plus buttons. The middle field is a real, editable
 * text input so the user can type a value directly in addition to stepping.
 */
export const NumberStepper = (props: NumberStepperProps) => {

    const { ariaLabel, disabled = false, max, min = 0, onChange, step = 1, suffix, value } = props;

    const clamp = (next: number): number => {

        let result = next;
        if (typeof min === 'number') result = Math.max(min, result);
        if (typeof max === 'number') result = Math.min(max, result);
        return result;

    };

    const handleInput = e => {

        const digits = e.target.value.replace(/[^0-9]/g, '');
        onChange(clamp(digits === '' ? min : parseInt(digits, 10)));

    };

    return (
        <InputGroup className={'number-stepper flex-nowrap'} style={{ maxWidth: 260, width: 'auto' }}>
            <GMetrixButton
                aria-label={`${ariaLabel ?? ''} decrease`.trim()}
                className={'border'}
                disabled={disabled || value <= min}
                iconClass={'fa-solid fa-minus'}
                onClick={() => onChange(clamp(value - step))}
                variant={'light'}
            />

            <Form.Control
                aria-label={ariaLabel}
                className={'text-center border-start-0 border-end-0'}
                disabled={disabled}
                inputMode={'numeric'}
                onChange={handleInput}
                style={{ minWidth: '3rem' }}
                value={String(value)}
            />

            {suffix && (
                <InputGroup.Text className={'bg-white text-muted'}>
                    {suffix}
                </InputGroup.Text>
            )}

            <GMetrixButton
                aria-label={`${ariaLabel ?? ''} increase`.trim()}
                className={'border'}
                disabled={disabled || (typeof max === 'number' && value >= max)}
                iconClass={'fa-solid fa-plus'}
                onClick={() => onChange(clamp(value + step))}
                variant={'light'}
            />
        </InputGroup>
    );

};
